import { render, staticRenderFns } from "./TaskFiles.vue?vue&type=template&id=1f547c4b&"
import script from "./TaskFiles.vue?vue&type=script&lang=js&"
export * from "./TaskFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports